import React, { useMemo } from "react";
import SubmitButton from "../../../components/button/SubmitButton";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { findObjectKeyByValue, validatePhone } from "../../../utils/helper";
import { GENDER, SNACK_BAR_VARIETNS } from "../../../utils/constants";
import moment from "moment";
import OscillaLauncher from "./Oscilla";
import AudioGram from "../AudioGram";
import OneViewBox from "../../../components/layouts/OneViewBox";
import { center } from "../../../assets/css/theme/common";
import { callApiAction } from "../../../store/actions/commonAction";
import { getSendMessageApi } from "../../../apis/oscilla.api";
import { callSnackBar } from "../../../store/actions/snackbarAction";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Navigate, useNavigate } from "react-router-dom";
import OtoScopDataUi from "../OtoScopeUi";
import SuggestedDevices from "../SuggestedDeviced";
import AudiogramReport from "./AudiogramReport";
import PersonalDetailsFields from "../PersonalDetailsFields";
import useValidate from "../../../store/hooks/useValidator";
import { startOscillaLoadingValues } from "../../../store/actions/OscillaDataAction";
import CloseIcon from "@mui/icons-material/Close";
import ReactDOM from "react-dom";

const BeneficiaryAudioGramUI = ({
  updateFunction,
  onValidate,
  updated_by,
  fields,
  setFields,
  _id,
  setOscillaAudiogramState,
  loading,
  setLoading,
  step,
  setStep,
  loadAudiogram,
  oscillaAudiogramState,
  fetchById,
}) => {
  const [msgLoading, setMsgLoading] = React.useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);

  const SendMessage = () => {
    setMsgLoading(true);
    dispatch(
      callApiAction(
        async () =>
          await getSendMessageApi({
            id: fields?._id,
            phonenumber: fields?.phone,
          }),
        (response) => {
          setMsgLoading(false);
          dispatch(
            callSnackBar(
              "Report Sent Successfully",
              SNACK_BAR_VARIETNS.suceess,
            ),
          );
        },
        (err) => {
          setMsgLoading(false);
          dispatch(
            callSnackBar("Failed to send report", SNACK_BAR_VARIETNS.error),
          );
        },
      ),
    );
  };
  const navigate = useNavigate();
  const validate = useValidate();
const validationSchemaForCreate = useMemo(
  () => [
    {
      required: true,
      value: fields.country,
      field: "Country",
    },
    {
      required: true,
      value: fields.state,
      field: "State",
    },
    {
      required: true,
      value: fields.district,
      field: "District",
    },
    {
      value: fields.taluka,
      field: "Taluka",
    },
    {
      required: true,
      value: fields.first_name,
      field: "First Name",
    },
    {
      required: true,
      value: fields.phone,
      field: "Phone No.",
      custom: () => {
        if (!validatePhone(fields.phone)) {
          return "Phone No is invalid.";
        }
        return true;
      },
    },
    {
      required: true,
      value: fields.gender,
      field: "Gender",
    },
    {
      required: true,
      value: fields.dob,
      field: "Date of Birth",
    },
    {
      required: true,
      value: fields.address_line,
      field: "Address",
    },
  ],
  [fields],
);
  console.log("fields", fields.first_name);
  return (
    <>
      {loading &&
        ReactDOM.createPortal(
          <Backdrop
            open={loading}
            sx={{
              zIndex: 99999,
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.65)",
              backdropFilter: "blur(2px)",
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={() => {
                dispatch(startOscillaLoadingValues(false));
              }}
              sx={{
                position: "fixed",
                top: 16,
                right: 16,
                zIndex: 100000,
                width: 48,
                height: 48,
                backgroundColor: "#fff",
                color: "#666",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* Loader */}
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{ pointerEvents: "none" }}
            >
              <CircularProgress size={50} />
            </Box>
          </Backdrop>,
          document.body,
        )}
      {step === 0 && (
        <Paper sx={{ p: 3, height: "100%" }}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "3%",
              }}
            >
              <IconButton
                fullWidth
                color="info"
                disableElevation
                size="inherit"
                onClick={() =>
                  step === 0
                    ? navigate("/beneficiary/beneficiary-data")
                    : setStep(step - 1)
                }
              >
                <KeyboardArrowLeftIcon /> <Typography>BACK</Typography>
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "97%",
              }}
            >
              <Typography variant="h6" mb={2}>
                Update Beneficiary
              </Typography>
            </Box>
          </Box>
          {
            <PersonalDetailsFields
              show={step == 0}
              fields={fields}
              setFields={setFields}
              loading={loading}
            />
          }

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box mt={2}>
              <SubmitButton
                onClick={() => {
                  const validationResponse = validate(
                    validationSchemaForCreate,
                  );

                  console.log("validationResponse", validationResponse);

                  if (validationResponse === true) {
                    setStep(step + 1);
                  } else {
                    dispatch(
                      callSnackBar(
                        validationResponse,
                        SNACK_BAR_VARIETNS.error,
                      ),
                    );
                  }
                }}
                type="button"
                sx={{ maxWidth: "200px" }}
                title={step === 1 ? "Submit" : "Next"}
              />
            </Box>
          </Box>
        </Paper>
      )}
      {step === 1 && (
        <Paper sx={{ p: 3, height: "100%" }}>
          <IconButton
            fullWidth
            color="info"
            disableElevation
            size="inherit"
            onClick={() =>
              step === 0
                ? navigate("/beneficiary/beneficiary-data")
                : setStep(step - 1)
            }
          >
            <KeyboardArrowLeftIcon /> <Typography>BACK</Typography>
          </IconButton>
          {
            <OtoScopDataUi
              fields={fields}
              setFields={setFields}
              fetchFunction={fetchById}
            />
          }

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box mt={2}>
              <SubmitButton
                onClick={() => {
                  setStep(step + 1);
                }}
                type="button"
                sx={{ maxWidth: "200px" }}
                title={step == 1 ? "Next" : "Submit" + ``}
              />
            </Box>
          </Box>
        </Paper>
      )}

      {step === 2 && (
        <Paper sx={{ p: 3 }}>
          <IconButton
            fullWidth
            color="info"
            disableElevation
            size="inherit"
            onClick={() =>
              step === 0
                ? navigate("/beneficiary/beneficiary-data")
                : setStep(step - 1)
            }
          >
            <KeyboardArrowLeftIcon /> <Typography>BACK</Typography>
          </IconButton>
          {
            <>
              <AudioGram
                fields={fields}
                setFields={setFields}
                setOscillaAudiogramState={setOscillaAudiogramState}
                oscillaAudiogramState={oscillaAudiogramState}
              />
              <Box sx={{ display: "flex", width: "100%", mt: 2 }}>
                {
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                      gap: 2,
                    }}
                  >
                    <Button
                      disabled={msgLoading}
                      onClick={SendMessage}
                      variant="contained"
                      color="primary"
                      sx={{ height: "5vh" }}
                    >
                      Send Report
                    </Button>
                  </Box>
                }
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <SubmitButton
                    variants="outlined"
                    type="button"
                    onClick={() => {
                      loadAudiogram();
                    }}
                    sx={{ maxWidth: "200px" }}
                    title={"LOAD AUDIOGRAM"}
                  />
                  <OscillaLauncher
                    wehearId={fields?._id}
                    updated_by={user?.data?._id}
                    patientId={_id}
                    firstName={fields?.first_name}
                    lastName={fields?.last_name}
                    org={user?.data?._id}
                    birthDate={
                      moment(fields?.dob).format("YYYYMMDD") || "20021130"
                    }
                    gender={findObjectKeyByValue(
                      Number(fields?.gender),
                      GENDER,
                    )}
                  />
                  <SubmitButton
                    disabled={!oscillaAudiogramState.allowed_Oscilla}
                    // variants="outlined"
                    type="button"
                    onClick={() => {
                      setStep(step + 1);
                    }}
                    sx={{ maxWidth: "200px" }}
                    title={step == 2 ? "Next" : "Submit" + ``}
                  />
                </Box>
              </Box>
            </>
          }
        </Paper>
      )}

      {step === 3 && (
        <>
          {" "}
          <Paper
            sx={{ p: 3 }}
            display="flex"
            flexDirection="column"
            height="100%"
            gap={10}
          >
            {" "}
            <IconButton
              fullWidth
              color="info"
              disableElevation
              size="inherit"
              onClick={() =>
                step === 0
                  ? navigate("/beneficiary/beneficiary-data")
                  : setStep(step - 1)
              }
            >
              <KeyboardArrowLeftIcon /> <Typography>BACK</Typography>
            </IconButton>
            <Box mb={3}>
              <AudiogramReport
                id={fields?._id || _id}
                name={
                  fields?.first_name +
                  " " +
                  (fields?.last_name ? fields?.last_name : "")
                }
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                alignItems: "flex-end",
              }}
            >
              <SubmitButton
                // variants="outlined"
                type="button"
                onClick={() => updateFunction()}
                sx={{ maxWidth: "200px" }}
                title={step == 3 ? "Update" : "Next" + ``}
              />
            </Box>
          </Paper>
        </>
      )}
    </>
  );
};

export default BeneficiaryAudioGramUI;
